export default __webpack_public_path__ + "static/logo_horizontal_reversed_mono_lockup-caa7ddc20560862e4561276ef027f219.svg";